import { GlobalSearchResults } from "@/utils/types/algolia";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  page: "",
};

const AdsSlice = createSlice({
  name: "ads",
  initialState,
  reducers: {
    setCurrentPage(state, action) {
      state.page = action?.payload || "";
    },
  },
});

export const { setCurrentPage } = AdsSlice.actions;
export const AdsReducer = AdsSlice.reducer;
